const pidController = (function () {
	const data = {
		mazda: {
			default: {
				requestQuote: {
					desktop: 101100110,
					tablet: 101100113,
					mobile: 101100114
				},
				reserveYours: {
					desktop: 101100154,
					tablet: 101100155,
					mobile: 101100156
				},
				preOrder: {
					desktop: 101100162,
					tablet: 101100163,
					mobile: 101100164
				},
				serviceAppt: {
					desktop: 601000,
					tablet: 101200101,
					mobile: 101200102
				},
				testDrive: {
					desktop: 101100111,
					tablet: 101100115,
					mobile: 101100116
				},
				tradeInValue: {
					desktop: 101102006,
					tablet: 101102007,
					mobile: 101102008
				},
				tradeInValueBnp: {
					desktop: 101102003,
					tablet: 101102004,
					mobile: 101102005
				},
				contactDealer: {
					desktop: 101100111,
					tablet: 101100115,
					mobile: 101100116
				},
				getLocalPrice: {
					desktop: 101100159,
					tablet: 101100160,
					mobile: 101100161
				}
			}
		},
		cpo: {
			details: {
				contact: {
					desktop: 101100136,
					tablet: 101100130,
					mobile: 101100133
				}
			},
			listing: {
				contact: {
					desktop: 101100135,
					tablet: 101100135,
					mobile: 101100132
				}
			},
			saved: {
				contact: {
					desktop: 101100137,
					tablet: 101100137,
					mobile: 101100137
				}
			}
		},
		buildPrice: {
				contactDealer: {
					desktop: 101100109,
					tablet: 101100121,
					mobile: 101100122
				},
				requestQuote: {
					desktop: 101100101,
					tablet: 101100117,
					mobile: 101100118
				},
				testDrive: {
					desktop: 101100102,
					tablet: 101100119,
					mobile: 101100120
				},
				preOrder:{
					desktop: 101100165,
					tablet: 101100166,
					mobile: 101100167
				}
		}
	};
	return {
		getPid: function (formType) {
			let pidValue, windowSize;
			const path = window.location.pathname;

			// Set window size
			if (window.outerWidth > 1025) {
				windowSize = 'desktop';
			} else if (window.outerWidth > 767) {
				windowSize = 'tablet';
			} else {
				windowSize = 'mobile';
			}

			if (path.search('build-and-price') >= 1 || path.search('construction-et-prix') >= 1) {

				try {
					pidValue = data['buildPrice'][formType][windowSize];
				}
				catch (err) {
					pidValue = null;
				}
			}
			// Otherwise
			else {
				try {
					pidValue = data['mazda']['default'][formType][windowSize];
				}
				catch (err) {
					pidValue = null;
				}
			}

			if (!pidValue) {
				pidValue = 0;
				console.log('Warning: pid not found in getPid in pidController.js');
			}
			return pidValue;
		},
	};
})();

export default pidController;